import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import GeneralLayout from 'src/layouts/general';
import { localeSelector } from 'src/selector/app';
import ProductTopIntroduction, {
  ProductTopIntroductionForLoyaltyMode,
} from 'src/components/POSWebsite/ProductTopIntroduction';
import ScheduleYourFreeDemo from 'src/components/POSWebsite/ScheduleYourFreeDemo';
import ProductAdvantages from 'src/components/POSWebsite/ProductAdvantages';
import ProudctFeaturies from 'src/components/POSWebsite/ProudctFeaturies';
import WhyChooseChowbus from 'src/components/POSWebsite/WhyChooseChowbus';
import UsingServiceAdvantage from '../../UsingServiceAdvantage';
import { Grid, Button, Row, Col } from 'antd';
import useSEOMeta from 'src/hooks/useSEOMetaHook';
import { useRouter } from 'next/router';
import useLocale from 'src/hooks/useLocale';

const { useBreakpoint } = Grid;
const ProductPage = ({
  pageId,
  pageContent,
  featureCardStyle = 'border_card',
  whyChowbusShowModel = 'default',
  templateMode = 'default',
  getADemoShowModel = 'lightGray_background',
  children,
  customerCaseKeys,
}) => {
  const locale = useLocale();
  const screens = useBreakpoint();
  const router = useRouter();
  const { keywords, pageTitle, metaDescription } = useSEOMeta({ pageId: pageId });

  const { advanceContent, featureContent2, featureContent, topIntroductionContent, whyChooseChowbusTitle } =
    useMemo(() => {
      let advanceContent = pageContent.advances[locale];
      let featureContent = pageContent.features[locale];
      let topIntroductionContent = pageContent.topSection[locale];
      let whyChooseChowbusTitle = pageContent.whyNotChooseChowBus?.[locale]?.title;
      let featureContent2 = pageContent.features2 ? pageContent.features2[locale] : null;
      return {
        advanceContent,
        featureContent,
        topIntroductionContent,
        featureContent2,
        whyChooseChowbusTitle,
      };
    }, [locale, pageContent]);

  const [showAsNormalTopLayout, setShowAsNormalTopLayout] = useState(templateMode === 'default');

  // screens.xs ? indexStyles.forMobile : '',
  // screens.md ? indexStyles.forMDDevice : '', //768
  // screens.sm && !screens.md ? indexStyles.forSMDevice : '' //576

  useEffect(() => {
    if (templateMode !== 'loyalty_waitlist') {
      setShowAsNormalTopLayout(true);
    } else if (screens.xs || (screens.sm && !screens.md) || (screens.md && !screens.lg)) {
      setShowAsNormalTopLayout(true);
    } else {
      setShowAsNormalTopLayout(false);
    }
  }, [templateMode, screens]);

  return (
    <GeneralLayout
      pageId={`pos-web-site-home-page-enh ${pageId}`}
      pageTitle={pageTitle}
      keywords={keywords}
      metaDescription={metaDescription}
    >
      {showAsNormalTopLayout ? (
        <ProductTopIntroduction
          title={topIntroductionContent.title}
          description={topIntroductionContent.description}
          descriptionHtml={topIntroductionContent.descriptionHtml}
          topLink={topIntroductionContent.topLink}
          poster={`${topIntroductionContent.poster}`}
          videoId={topIntroductionContent.youtubeVideoId}
        />
      ) : (
        <ProductTopIntroductionForLoyaltyMode
          title={topIntroductionContent.title}
          description={topIntroductionContent.description}
          poster={`${topIntroductionContent.poster}`}
          videoId={topIntroductionContent.youtubeVideoId}
        />
      )}

      <ProductAdvantages
        title={advanceContent.title}
        description={advanceContent.subTitle}
        features={advanceContent.featureList}
        poster={`${topIntroductionContent.poster}`}
        videoId={topIntroductionContent.youtubeVideoId}
      />
      <ProudctFeaturies feature={featureContent} cardStyle={featureCardStyle} />
      {children && children}
      <WhyChooseChowbus
        whyChooseChowbusTitle={whyChooseChowbusTitle}
        showModel={whyChowbusShowModel || 'default'}
        customerCaseKeys={customerCaseKeys}
      />
      {featureContent2 && <UsingServiceAdvantage content={featureContent2} productMode={true} />}
      <ScheduleYourFreeDemo showModel={getADemoShowModel || 'lightGray_background'} />
    </GeneralLayout>
  );
};

export default ProductPage;
